<h2 mat-dialog-title class="text-lg font-bold flex items-center gap-2">
  <mat-icon class="text-green-600">check_circle</mat-icon>
  Viajes Generados Exitosamente
</h2>
<mat-dialog-content class="flex flex-col gap-4 py-4 min-w-[360px] max-sm:min-w-full">
  <p class="text-sm text-secondary">
    La ejecución del Job finalizó. Los viajes creados en esta corrida se muestran a continuación. 
    Las filas en verde representan los viajes correspondientes a la subruta <strong>{{ data.currentSubRouteName }}</strong>:
  </p>

  <div class="trips-table border rounded-md overflow-hidden bg-card">
    <table mat-table [dataSource]="dataSource" class="w-full">
      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="px-4">Nº Viaje</th>
        <td mat-cell *matCellDef="let element" class="px-4 font-semibold text-sm">
          {{ element.id }}
        </td>
      </ng-container>

      <!-- Descripción -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef class="px-4">Descripción</th>
        <td mat-cell *matCellDef="let element" class="px-4 text-sm">
          {{ element.description || '-' }}
        </td>
      </ng-container>

      <!-- Subruta -->
      <ng-container matColumnDef="subRoute">
        <th mat-header-cell *matHeaderCellDef class="px-4">Subruta</th>
        <td mat-cell *matCellDef="let element" class="px-4 text-sm">
          {{ element.subRoute?.name || '-' }}
        </td>
      </ng-container>

      <!-- Rango de fecha -->
      <ng-container matColumnDef="dateRange">
        <th mat-header-cell *matHeaderCellDef class="px-4">Período Teórico</th>
        <td mat-cell *matCellDef="let element" class="px-4 text-sm">
          <span>{{ element.dateHourStartTeoric | date: 'dd/MM/yyyy HH:mm' }}</span> - 
          <span>{{ element.dateHourEndTeoric | date: 'dd/MM/yyyy HH:mm' }}</span>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="px-4 text-center">Enlace</th>
        <td mat-cell *matCellDef="let element" class="px-4 text-center">
          <button mat-icon-button color="primary" matTooltip="Ir al Viaje" (click)="navigateToTrip(element)">
            <mat-icon>open_in_new</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
          [class.highlight-row]="isCurrentSubRoute(row)"
          class="border-b hover:bg-gray-50"></tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-end gap-3 px-6 pb-4 pt-2">
  <button mat-flat-button color="primary" (click)="onClose()">
    Aceptar
  </button>
</mat-dialog-actions>
